const aptRegex =
  /\b(apt|bldg|dept|fl|hngr|lot|pier|rm|ste|slip|trlr|unit|#)[.-]? *\w+\b/gi;
const poBoxRegex = /\bP\.? ?O\.? *Box *\d+\b/gi;
const roadRegex =
  /\b(street|st|road|rd|avenue|ave|drive|dr|loop|court|ct|circle|cir|lane|ln|boulevard|blvd|way)\b/gi;
export const streetAddress = new RegExp(
  '(\\d+\\s*(\\w+ ){1,2}' +
    roadRegex.source +
    '(\\s+' +
    aptRegex.source +
    ')?)|(' +
    poBoxRegex.source +
    ')',
  'gi',
);
export const creditCardNumber = /(?:\d[ -]*?){13,16}/g;
export const phoneNumber =
  /(\+?\d{1,2}[-. ]?)?\(?\d{3}\)?[-. ]?\d{3}[-. ]?\d{4}/g;
export const ipAddress = /\d{1,3}[.]\d{1,3}[.]\d{1,3}[.]\d{1,3}/g;
export const usSocialSecurityNumber = /\d{3}[ -]?\d{2}[ -]?\d{4}/g;
export const emailAddress = /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/g;
export const url = /^((ftp|http|https):\/\/)?(www\.)?([A-z]+)\.([A-z]{2,})/g;
